import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styles from './RadioBoxInput.css';
import { bem } from '../../../helpers/styles';

function RadioBoxInput({ flex, value, onChange, options }) {
  // Callback optimisé pour éviter les fonctions inline dans le map
  const handleOptionClick = useCallback((optionValue) => {
    return () => onChange(optionValue);
  }, [onChange]);

  return (
    <div className={bem(styles, 'RadioBoxInput', { flex })}>
      {options.map((option, i) => (
        <button
          type="button"
          className={bem(styles, 'RadioBoxInput__option', {
            selected: value === option.value,
          })}
          key={i}
          onClick={handleOptionClick(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

RadioBoxInput.propTypes = {
  flex: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
};

export default RadioBoxInput;
